// Path: ./jquery-stub.js
module.exports = null;
